import { createSelector } from 'reselect';
import { selectors as groupSelectors } from '../groups';

const allGroups = groupSelectors.byId;

// returns a hash from group_id -> list of tasks that belong to that group
export const availabilityRequirementsPerGroup = createSelector(allGroups, groups => {
  const result = {};
  for (const group of Object.values(groups)) {
    for (const ar of group.availability_requirements) {
      result[group.id] = result[group.id] || [];
      result[group.id].push(ar);
    }
  }
  return result;
});

// Returns the IDs of the availability requirements that are hidden by the
// current user
export const hiddenAvailabilityRequirementIds = state => {
  return state.currentUser.data.hidden_availability_requirement_ids || [];
};

export default {
  availabilityRequirementsPerGroup,
  hiddenAvailabilityRequirementIds
};
